import { SendOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row } from "antd";

const FactoryInput = ({
    newMessage,
    setNewMessage,
    handleSendMessage,
    isLoading,
    messageApi,
    styles,
    inputRef,
}) => (
    <Row gutter={10}>
        <Col flex="auto">
            <Input
                ref={inputRef}
                placeholder="Escribe un mensaje"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onPressEnter={() => handleSendMessage(messageApi)}
                disabled={isLoading}
            />
        </Col>
        <Col>
            <Button
                type="primary"
                onClick={() => handleSendMessage(messageApi)}
                loading={isLoading}
            >
                <SendOutlined />
                Enviar
            </Button>
        </Col>
    </Row>
);

export default FactoryInput;